import { render, staticRenderFns } from "./InfoGasType.vue?vue&type=template&id=5b260c76&"
import script from "./InfoGasType.vue?vue&type=script&lang=js&"
export * from "./InfoGasType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports